import { Controller } from "@hotwired/stimulus";
// Connects to data-controller="load-more"
export default class extends Controller {
  static targets = ["button", "loading", "container", "loadMoreSection"];

  connect() {
    console.log("Load more controller connected");
  }

  async loadMore(event) {
    event.preventDefault();

    const link = event.target;
    const url = link.href;

    // Show loading state
    this.showLoading();

    // Disable link to prevent double clicks
    link.style.pointerEvents = "none";

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();

      // Let Turbo Stream handle the response
      Turbo.renderStreamMessage(html);

      // Add smooth scroll animation to new items
      this.animateNewItems();
    } catch (error) {
      console.error("Error loading more offers:", error);
      this.showError();
    } finally {
      // Hide loading state
      this.hideLoading();
      link.style.pointerEvents = "auto";
    }
  }

  showLoading() {
    this.buttonTarget.style.opacity = "0.5";
    this.loadingTarget.classList.remove("hidden");
  }

  hideLoading() {
    this.buttonTarget.style.opacity = "1";
    this.loadingTarget.classList.add("hidden");
  }

  showError() {
    const errorMessage = document.createElement("div");
    errorMessage.className = "error-message";
    errorMessage.textContent = "Failed to load more offers. Please try again.";

    this.loadMoreSectionTarget.appendChild(errorMessage);

    // Remove error message after 5 seconds
    setTimeout(() => {
      errorMessage.remove();
    }, 5000);
  }

  animateNewItems() {
    // Get recently added items
    const offerCards = this.containerTarget.querySelectorAll(".offer-card");
    const newItems = Array.from(offerCards).slice(-2); // Assuming 2 items per page

    newItems.forEach((item, index) => {
      item.style.opacity = "0";
      item.style.transform = "translateY(20px)";

      setTimeout(() => {
        item.style.transition = "opacity 0.5s ease, transform 0.5s ease";
        item.style.opacity = "1";
        item.style.transform = "translateY(0)";
      }, index * 100); // Stagger the animation
    });

    // Smooth scroll to show new content
    if (newItems.length > 0) {
      setTimeout(() => {
        newItems[0].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }, 300);
    }
  }
}
